import { Action, Pill } from '@/types/EntityDetails';
import React from 'react';

type Props = {
  icon?: JSX.Element;
  entityPills?: Pill[];
  actions?: Action[];
  basicInfo: JSX.Element[];
  pills: JSX.Element[];
  entityGrid: JSX.Element[];
  actionButtons: JSX.Element[];
};

const EntityDetailsSummaryMobileView = ({ icon, entityPills, basicInfo, pills, entityGrid, actions, actionButtons }: Props) => (
  <div className="entity-summary-info-card">
    <div className="entity-summary-info-container">
      <div className="entity-summary-details-wrapper-container">
        {icon && icon}
        <div className="entity-summary-details-wrapper">
          <div className="entity-summary-basic-info-container">
            <div className="entity-summary-basic-info">
              <div className="entity-summary-basic-info-fields">{basicInfo}</div>
              {entityPills && entityPills.length > 0 && <div className="entity-summary-pills-container">{pills[0]}</div>}
            </div>
            <div className="entity-summary-details-fields">{entityGrid}</div>
          </div>
        </div>
      </div>

      {actions && <div className="entity-summary-actions-container">{actionButtons}</div>}
    </div>
  </div>
);

export default EntityDetailsSummaryMobileView;
